"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fuseResponsiveGrid = require("@tvg/fuse-responsive-grid");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var defineSize = function defineSize(size, type) {
  var fontSize = "var(--font-size-".concat(size.toLowerCase().replace('t', ''), ")");
  var lineHeight = "var(--font-line-height-".concat(size.toLowerCase().replace('t', ''), ")");
  var paragraphMarginBottom = "var(--spacing-paragraph-margin-bottom-".concat(size.toLowerCase(), ")");
  return "font-size: ".concat(fontSize, ";\n            line-height: ").concat(lineHeight, ";\n            margin-bottom: ").concat(type === 'paragraph' ? paragraphMarginBottom : '', ";");
};
var StyledTypography = _styledComponents["default"].h1.withConfig({
  displayName: "styled-typography__StyledTypography",
  componentId: "sc-1x76dv7-0"
})(["", ""], function (_ref) {
  var color = _ref.color,
    type = _ref.type,
    size = _ref.size;
  var typographyColour = color || "var(--color-font-".concat(type, ")");
  var viewportSizes = typeof size === 'string' || size instanceof String ? defineSize(size, type) : ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'].filter(function (viewport) {
    return size[viewport];
  }).map(function (viewport) {
    return "@media screen and (min-width: ".concat(_fuseResponsiveGrid.gridConfig[viewport].minWidth, ") {\n                        ").concat(defineSize(size[viewport], type), "\n                    }");
  }).join('');
  return "\n            color: ".concat(typographyColour, ";\n            font-weight: var(--font-weight-").concat(type, ");\n\n            ").concat(viewportSizes, "\n\n            a {\n                color: var(--color-global-black);\n\n                &:active,\n                &:focus {\n                    outline: 2px solid var(--color-functional-focus);\n                }\n\n                &:visited {\n                    color: var(--color-global-grey800);\n                }\n\n                &:visited:hover,\n                &:visited:focus,\n                &:hover,\n                &:focus {\n                    color: var(--color-brand-dark);\n                }\n\n                &:active,\n                &:visited:active {\n                    color: var(--color-global-black);\n                }\n            }\n        ");
});
var _default = exports["default"] = StyledTypography;